//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isMobile, isFluterMirror } from '@/utils/constants';
import { afterLoginSuccess, afterLoginFail, clearLoginEvent } from '@/utils/userTools';
import { clearRecordNum } from '@/components/subscription/subscription';
import { loginToast } from '@/utils/loginToast';

const detail_map = {
  login: 'header_login',
  register: 'header_register',
};

export default {
  components: {},
  props: {},
  data() {
    return {
      login_mark: false,
      current_url: location.pathname.substr(1, location.pathname.length - 1),
      isMobile: isMobile(),
    };
  },
  computed: {
    actionData() {
      const val = this.type;
      const action_val = detail_map[val] || '';
      const action_detail = {
        login_popout_load: action_val,
        click_lanhuoauthbtn: 'login_popout',
        wechat_qr_load: 'login_popout',
      };
      return {
        actionType: this.type,
        actionPosition: 'masterUniverse',
        actionDetail: action_detail,
      };
    },
    disableOptions() {
      return {
        lanhu: isFluterMirror(),
        google: true,
        linkedin: true,
        twitter: true,
        thirdPartLogin: this.isMobile,
        wechat: false,
        dingding: false,
        mirrorDisabled: false,
        showPrivacy: false,
        wecom: true,
      };
    },
  },
  mounted() {
    if (this.type) {
      this.login_mark = true;
    }
  },
  watch: {
    login_mark() {
      window.$nuxt.$store.dispatch('user/setSubScribe', false);
    },
  },
  methods: {
    toastHandle(toastOptions)  {
      loginToast(toastOptions, this.$message);
    },
    ceshi_login() {
      this.login_mark = true;
    },
    closeLogin() {
      this.login_mark = false;
      if (!window.$nuxt.$store.state.user.userInfo.id) {
        let key = 'MG_SUBS_RESOURCE';
        if (this.current_url.indexOf('plugin') !== -1) {
          key = 'MG_SUBS_PLUGIN';
        }
        if (this.current_url.indexOf('activity') !== -1) {
          key = 'MG_SUBS_ACTIVITY';
        }
        try {
          const subs = JSON.parse(localStorage.getItem(key));
          if (subs) {
            if (subs.createTime === 0) {
              window.$nuxt.$store.dispatch('user/setSubScribe', true);
            }
          } else {
            window.$nuxt.$store.dispatch('user/setSubScribe', true);
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (afterLoginFail.length) {
        afterLoginFail.forEach((fn) => {
          try {
            fn();
          } catch (e) {
            console.error(e);
          }
        });
      }

      clearLoginEvent();
    },
    ceshi_route() {
      this.$router.push({ path: '/' });
    },
    setUserInfo(user_info, cancelReloadflag) {
      if (process.client) {
        window.$nuxt.$store.commit('user/setUserInfo', user_info);
        clearRecordNum();
      }
      if (!cancelReloadflag) {
        if (afterLoginSuccess.length) {
          afterLoginSuccess.forEach((fn) => {
            try {
              fn();
            } catch (e) {
              console.error(e);
            }
          });
          clearLoginEvent();
          this.closeLogin();
          return;
        }
        location.reload();
      }
    },
    turnPage(path, type) {
      if (type === 'forgetPassword') {
        window.open(`${window.location.origin}/login/forget-password`);
      } else {
        location.reload();
      }
    },
  },
};
